import Cart from './Cart';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './Cart.state';

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
